import {Sudbina} from "../../../komponente/sudbina/Sudbina";
import podaci from './podaci.json';

export default class Odvodjenje extends Sudbina {
  constructor() {
    super(podaci);
  }
}



// WEBPACK FOOTER //
// ./src/hronologija/1941/05-10/odvodjenje.js